// Saga to handle fetching tax document data.
import { takeLatest, put, call } from 'redux-saga/effects';
import { NetworkManager } from '../../api/NetworkManager';
import {
  getPensionVerificationListSuccess,
  getPensionVerificationListFailure,
  getPensionVerificationSuccess,
  getPensionVerificationFailure,
  postRegeneratePensionVerificationSuccess,
  postRegeneratePensionVerificationFailure,
} from './action';
import {
  GET_PENSION_VERIFICATION_LIST,
  GET_PENSION_VERIFICATION,
  POST_REGENERATE_PENSION_VERIFICATION,
} from './constant';

// Utility to convert Blob to base64
export function* blobToBase64(blob: Blob): any {
  return yield new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      const base64Data = result.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Get Pension Verification List API Saga.
export function* getPensionVerificationListData(action) {
  try {
    const { account, token } = action.payload;
    const response = yield call(NetworkManager.getPensionVerificationListData,account,token);
    if (response?.data) {
      yield put(getPensionVerificationListSuccess(response.data));
    } else {
      yield put(getPensionVerificationListFailure({ message: 'No data returned' }));
    }
  } catch (error) {
    yield put(getPensionVerificationListFailure(error));
  }
}

// Get Pension Verification Document API Saga.
export function* getPensionVerificationSaga(action) {
  try {
    const { planId, documentId, token } = action.payload;

    const response = yield call(
      NetworkManager.getPensionVerificationDocument,
      planId,
      documentId,
      token
    );
    const base64 = response?.data?.pvlDocument;
    if (!base64) {
      throw new Error("PDF base64 missing in API response");
    }
    yield put(getPensionVerificationSuccess(base64));
  } catch (error) {
    yield put(getPensionVerificationFailure(error));
  }
}

// Post Regenerate Pension Verification API Saga.
export function* postRegeneratePensionVerificationSaga(action) {
  try {
    const { account, token } = action.payload;
    const response = yield call(NetworkManager.postRegeneratePensionVerification, account, token);
    if (response?.data) {
      yield put(postRegeneratePensionVerificationSuccess(response.data));
    } else {
      yield put(postRegeneratePensionVerificationFailure({ message: 'No data returned' }));
    }
  } catch (error) {
    yield put(postRegeneratePensionVerificationFailure(error));
  }
}

export function* watchPensionVerificationSaga() {
  yield takeLatest(GET_PENSION_VERIFICATION_LIST, getPensionVerificationListData);
  yield takeLatest(GET_PENSION_VERIFICATION, getPensionVerificationSaga);
  yield takeLatest(POST_REGENERATE_PENSION_VERIFICATION, postRegeneratePensionVerificationSaga);
}